import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setAuthCode } from "../../../reducers/authorization/authorizationcodeSlices";
import { setUserSession } from "../../../reducers/sessions/sessionauthcodeSlices";
import { BaseUrlAuth } from "../../../services/axios/AxiosEndpoints";
import Swal from "sweetalert2";
import axios from "axios";
import styled from "@emotion/styled";
import DOMPurify from "dompurify";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
} from "@mui/material";
import Modal from "@mui/material/Modal";

/* --------------------------------------- --------------------------------------- */

const FormAuthCode = () => {
  /* Datos almacenados en redux */
  const { usuario, clave, codPss } = useSelector((state) => state.user);
  /* Variable para disparar funciones de redux */
  const dispatch = useDispatch();
  /* variable que tendra el valor del plastico */
  const [codigo, setCodigo] = useState("");
  /* Mensajes de status del formulario validar código */
  const [Mensaje, setMensaje] = useState("");
  /* variable que guarda la edad del afiliado */
  const [Edad, setEdad] = useState(0);
  /* Datos que se reciben del servidor al hacer el post */
  const [postuserInfo, setPostUserInfo] = useState({});
  /* Checked para seleccionar la poliza*/
  const [checked, setChecked] = useState(false);
  /* Checked para seleccionar la poliza*/
  const [checkedPoliza, setCheckedPoliza] = useState(true);
  /* Checked para seleccionar la  cedula */
  const [checkedCedula, setCheckedCedula] = useState(false);
  /* Variable que almacena el hash base64 de la imagen */
  let imageData;

  /* --------------------------------------- estilos de la tabla --------------------------------------- */

  const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#46cffa",
      color: "white",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(() => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "white",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  /* --------------------------------------- estilos del modal --------------------------------------- */

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  // ---------------------------- Estado del modal de ver el carnet ------------------------------ //

  const [openModalCarnet, setOpenModalCarnet] = useState(false);

  const handleCloseModalCarnet = () => setOpenModalCarnet(false);

  /* ------------------------------------------------------------------------------------- */

  const HandleChangeCedula = (e) => {
    // Obtén el valor actual del campo de identificación
    let { value } = e.target;

    // Elimina los guiones existentes, si los hay
    value = value.replace(/-/g, "");

    // Agrega guiones en las posiciones correctas
    if (value.length > 2 && value.length <= 11) {
      value = `${value.slice(0, 3)}-${value.slice(3, 10)}-${value.slice(10)}`;
    }

    // Actualiza el estado con el nuevo valor formateado
    setCodigo(value);
    //setCodigoAfil(value);
  };

  /* ------------------------------------------------------------------------------------- */

  const HandleChangePoliza = (e) => {
    // Obtén el valor actual del campo de identificación
    let { value } = e.target;

    // Elimina los guiones existentes, si los hay
    value = value.replace(/-/g, "");

    // Agrega guiones en las posiciones correctas
    if (value.length > 5 && value.length <= 12) {
      value = `${value.slice(0, 5)}-${value.slice(5, 10)}-${value.slice(10)}`;
    }

    // Actualiza el estado con el nuevo valor formateado
    setCodigo(value);
    //setCodigoAfil(value);
  };

  /* ------------------------------------------------------------------------------------- */

  const HandleChangeFunction = () => {
    setChecked(!checked);

    if (!checked) {
      setChecked(true);
      setCheckedPoliza(false);
      setCheckedCedula(true);

      const inputDOM = document.getElementById("plastico");
      inputDOM.value = "";

      setCodigo("");
    } else {
      setChecked(false);
      setCheckedCedula(false);
      setCheckedPoliza(true);

      const inputDOM = document.getElementById("plastico");
      inputDOM.value = "";

      setCodigo("");
    }
  };

  /* ------------------------------------------------------------------------------------- */

  const HandleSubmitPlastico = async (e) => {
    e.preventDefault();

    const sanitizedPlastico = DOMPurify.sanitize(codigo);

    await axios({
      url: `${BaseUrlAuth}/iniciarSesion`,
      method: "POST",
      data: JSON.stringify({
        auth: {
          usuario: usuario,
          password: clave,
          codPss: codPss,
        },
        plastico: sanitizedPlastico,
      }),
      headers: {
        Accept: "Application/json, text/plain, */*",
        "Content-Type": "Application/json",
      },
    })
      .then((response) => {
        if (response.status === 200) {
          setPostUserInfo(response.data);
          const { resp } = response.data;
          setMensaje(resp.mensaje);
          dispatch(
            setAuthCode({
              plastico: codigo,
              message: resp.mensaje,
            })
          );
          dispatch(
            setUserSession({
              usersession: response.data,
            })
          );
        } else {
          let mensajeError = "Código de afiliado inválido";
          setMensaje(mensajeError);
        }
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 400) {
            setMensaje("El recurso no fue encontrado.");
          } else if (error.response.status === 500) {
            setMensaje("Ha ocurrido un error en el servidor");
          }

          const { resp } = error.response.data;
          setMensaje(resp.detalle);
          Swal.fire({
            title: "",
            text: resp.detalle,
            icon: "warning",
            confirmButtonText: "Ok",
          });
        } else if (error.request) {
          setMensaje(error.request);
          Swal.fire({
            title: "",
            text: error.request,
            icon: "warning",
            confirmButtonText: "Ok",
          });
        }
      });
  };

  /* Funcion donde se calcula la edad del afiliado en base a su fecha de nacimiento */

  useEffect(() => {
    const { fechaNacimiento } = postuserInfo;

    if (postuserInfo) {
      function Edad() {
        let fechaNace = new Date(fechaNacimiento);
        let fechaActual = new Date();

        let mes = fechaActual.getMonth();
        let dia = fechaActual.getDate();
        let año = fechaActual.getFullYear();

        fechaActual.setDate(dia);
        fechaActual.setMonth(mes);
        fechaActual.setFullYear(año);

        let edad = Math.floor(
          (fechaActual - fechaNace) / (1000 * 60 * 60 * 24) / 365
        );

        return edad;
      }

      setEdad(Edad);
    }
  }, [postuserInfo]);

  /* ------------------------------------------------------------------------------------- */

  return (
    <Container
      sx={{
        width: "100%",
        padding: "0px",
        margin: "0px",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Stack
          component="form"
          sx={{
            width: "100%",
            mt: 5,
            p: 0,
          }}
          onSubmit={HandleSubmitPlastico}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "row",
                lg: "row",
              },
            }}
          >
            <Typography
              htmlFor="plastico"
              sx={{
                textAlign: "start",
                fontWeight: 500,
                fontSize: 16,
                mb: 0,
              }}
            >
              <Checkbox
                checked={checkedCedula}
                onChange={(e) => HandleChangeFunction(e)}
                inputProps={{ "aria-label": "controlled" }}
              />
              CÉDULA
            </Typography>

            <Typography
              htmlFor="plastico"
              sx={{
                textAlign: "start",
                fontWeight: 500,
                fontSize: 16,
                mb: 0,
              }}
            >
              <Checkbox
                checked={checkedPoliza}
                onChange={(e) => HandleChangeFunction(e)}
                inputProps={{ "aria-label": "controlled" }}
              />
              PÓLIZA
            </Typography>
          </Box>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "row",
                lg: "row",
              },
              justifyContent: "flex-start",
              margin: 0,
              padding: 0,
              left: 0,
            }}
          >
            {!checked ? (
              <Box
                sx={{
                  width: "auto",
                }}
              >
                <TextField
                  letiant="outlined"
                  size="small"
                  type="text"
                  id="plastico"
                  name="plastico"
                  placeholder="Identificación del afiliado"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="EJEMPLO: 
              POLIZA XXXXX-XXXXX-XX  
              CEDULA XXX-XXXXXXX-X"
                  value={codigo}
                  onChange={HandleChangePoliza}
                  inputProps={{
                    maxLength: 14,
                  }}
                  sx={{
                    width: { xs: "100%", sm: "100%", md: "300px", lg: "300px" },
                    height: "auto",
                  }}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  width: "auto",
                }}
              >
                <TextField
                  letiant="outlined"
                  size="small"
                  type="text"
                  id="plastico"
                  name="plastico"
                  placeholder="Identificación del afiliado"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="EJEMPLO: 
                POLIZA XXXXX-XXXXX-XX  
                CEDULA XXX-XXXXXXX-X"
                  value={codigo}
                  onChange={HandleChangeCedula}
                  inputProps={{
                    maxLength: 13,
                  }}
                  sx={{
                    width: { xs: "100%", sm: "100%", md: "300px", lg: "300px" },
                    height: "auto",
                  }}
                />
              </Box>
            )}
            <Box
              sx={{
                width: "auto",
                mt: 0,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="success"
                sx={{
                  left: { xs: "0px", sm: "0px", md: "20px", lg: "20px" },
                  top: { xs: "15px", sm: "15px", md: "0px", lg: "0px" },
                  fontSize: 16,
                }}
              >
                Validar
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>

      <Modal
        open={openModalCarnet}
        onClose={handleCloseModalCarnet}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img
            src={`data:image/png;base64,${imageData}`}
            alt="imagen"
            style={{ width: "100%", height: "40%", marginBottom: "20px" }}
          />
        </Box>
      </Modal>

      {/* -------- Formulario para mostrar los datos del usuario una vez haya sido verificado -------- */}
      {Mensaje === "OK" && Mensaje === "OK" ? (
        <>
          <Box sx={{ marginTop: "40px" }}>
            {Mensaje === "OK" && Mensaje === "OK" ? (
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>NOMBRES</StyledTableCell>
                      <StyledTableCell>APELLIDOS</StyledTableCell>
                      <StyledTableCell>CEDULA</StyledTableCell>
                      <StyledTableCell>IDENTIFICACIÓN</StyledTableCell>
                      <StyledTableCell>GÉNERO</StyledTableCell>
                      <StyledTableCell>EDAD</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell>{postuserInfo.nombres}</StyledTableCell>
                      <StyledTableCell>
                        {postuserInfo.apellidos}
                      </StyledTableCell>
                      <StyledTableCell>{postuserInfo.cedula}</StyledTableCell>
                      <StyledTableCell>{postuserInfo.plastico}</StyledTableCell>
                      <StyledTableCell>{postuserInfo.genero}</StyledTableCell>
                      <StyledTableCell>{Edad}</StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            ) : null}
          </Box>
        </>
      ) : null}
    </Container>
  );
};

export default FormAuthCode;
